"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var ramda_1 = require("ramda");
var dayjs_1 = __importDefault(require("dayjs"));
var utils_1 = require("../../utils/utils");
var selectors_1 = require("../channels/selectors");
var fastMemoize_1 = __importDefault(require("../../utils/fastMemoize"));
var constants_1 = require("./constants");
exports.slotsByChannelIdState = reselect_1.createSelector(function (state) { return state.epg.slotsByChannelId; }, function (s) { return s; });
exports.allSlots = reselect_1.createSelector(function (state) { var _a; return (_a = state.epg.slotsByChannelId) === null || _a === void 0 ? void 0 : _a.data; }, function (s) { return s; });
exports.getSlotsByChannelId = reselect_1.createSelector(function (state) { var _a; return (_a = state.epg.slotsByChannelId) === null || _a === void 0 ? void 0 : _a.data; }, function (allSlotsByChannelId) {
    return fastMemoize_1.default(function (channelId, from, to) {
        var slots = allSlotsByChannelId[channelId];
        if (slots) {
            if (utils_1.isNotNilOrEmpty(from) || utils_1.isNotNilOrEmpty(to)) {
                var startIndex = slots.findIndex(function (slot) { return dayjs_1.default(from).unix() < dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.end).unix(); });
                var endIndex = slots.findIndex(function (slot) { return dayjs_1.default(to).unix() <= dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.end).unix(); });
                return slots.slice(startIndex >= 0 ? startIndex : 0, endIndex >= 0 ? endIndex + 1 : undefined);
            }
            return slots;
        }
        return [];
    });
});
exports.slotsByChannelIdIsLoading = reselect_1.createSelector(function (state) { var _a; return (_a = state.epg.slotsByChannelId) === null || _a === void 0 ? void 0 : _a.isLoading; }, function (isLoading) { return !!isLoading; });
exports.slotsByChannelIdError = reselect_1.createSelector(function (state) { return state.epg.slotsByChannelId.error; }, function (error) { return error; });
exports.getSlotsByCategoryId = reselect_1.createSelector(selectors_1.getChannelsByCategoryId, exports.getSlotsByChannelId, function (getChannels, getSlots) {
    return fastMemoize_1.default(function (categoryId) {
        var targetChannels = getChannels(categoryId);
        return targetChannels === null || targetChannels === void 0 ? void 0 : targetChannels.map(function (channel) { return getSlots(channel.id); });
    });
});
exports.isSlotsOutsideTimeRange = reselect_1.createSelector(selectors_1.channels, exports.getSlotsByChannelId, function (allChannels, getSlots) {
    return fastMemoize_1.default(function (from, to) {
        if (ramda_1.isEmpty(allChannels) || ramda_1.isNil(allChannels)) {
            return true;
        }
        return allChannels === null || allChannels === void 0 ? void 0 : allChannels.some(function (channel) {
            var slots = getSlots(channel.id);
            if (ramda_1.isEmpty(slots) || ramda_1.isNil(slots)) {
                return true;
            }
            var startIndex = slots.findIndex(function (slot) {
                return dayjs_1.default(from).unix() >= dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.start).unix() &&
                    dayjs_1.default(from).unix() < dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.end).unix();
            });
            var endIndex = slots.findIndex(function (slot) {
                return dayjs_1.default(to).unix() > dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.start).unix() &&
                    dayjs_1.default(to).unix() <= dayjs_1.default(slot === null || slot === void 0 ? void 0 : slot.end).unix();
            });
            return startIndex < 0 || endIndex < 0;
        });
    });
});
exports.getSlotsByTimeRange = reselect_1.createSelector(selectors_1.getChannelsByCategoryId, exports.getSlotsByChannelId, function (getChannels, getSlots) {
    return fastMemoize_1.default(function (categoryId, from, to) {
        var targetChannels = getChannels(categoryId);
        return targetChannels === null || targetChannels === void 0 ? void 0 : targetChannels.map(function (channel) { return getSlots(channel.id, from, to); });
    });
});
exports.selectedSlot = reselect_1.createSelector(function (state) { return state.epg.selectedSlot.data; }, function (slot) { return slot; });
exports.selectedSlotChannel = reselect_1.createSelector(function (state) { return state.epg.selectedSlot.data; }, function (slot) { return slot === null || slot === void 0 ? void 0 : slot.channel; });
exports.selectedSlotIsLoading = reselect_1.createSelector(function (state) { return state.epg.selectedSlot.isLoading; }, function (isLoading) { return !!isLoading; });
exports.selectedSlotError = reselect_1.createSelector(function (state) { return state.epg.selectedSlot.error; }, function (error) { return error; });
exports.scheduledSlotsState = reselect_1.createSelector(function (state) { return state.epg.scheduledSlots; }, function (s) { return s; });
exports.scheduledSlots = reselect_1.createSelector(function (state) { return state.epg.scheduledSlots.data; }, function (data) { return data.filter(function (slot) { return !!slot.slot; }).map(function (slot) { return slot.slot; }); });
//# sourceMappingURL=selectors.js.map